
import { supabase } from '../client';

/**
 * Migrate groups from localStorage to Supabase
 */
export const migrateGroups = async (userId: string, localGroups: any[]) => {
  if (localGroups.length === 0) {
    console.log('No groups to migrate');
    return { 
      groups: { count: 0, success: true },
      productGroups: { count: 0, success: true }
    };
  }

  console.log(`Migrating ${localGroups.length} groups`);
  const result = {
    groups: { count: 0, success: true },
    productGroups: { count: 0, success: true }
  };
  
  for (const group of localGroups) {
    try {
      // Convert group to database format
      const dbGroup = {
        id: group.id,
        user_id: userId,
        name: group.name,
        description: group.description,
        created_at: group.createdAt,
        updated_at: group.updatedAt
      };

      // Insert or update the group
      const { error: insertError } = await supabase
        .from('groups')
        .upsert(dbGroup);

      if (insertError) {
        console.error('Error migrating group:', insertError);
        result.groups.success = false;
      } else {
        result.groups.count++;
        console.log(`Migrated group: ${group.name}`);
      }

      // Create product-group relationships
      if (group.productIds && group.productIds.length > 0) {
        console.log(`Creating ${group.productIds.length} product-group relationships for group ${group.name}`);
        
        // First delete existing relationships for this group to prevent duplicates
        await supabase
          .from('product_groups')
          .delete()
          .eq('group_id', group.id);
        
        // Create new relationship entries
        const productGroups = group.productIds.map((productId: string) => ({
          product_id: productId,
          group_id: group.id
        }));

        const { error: relationError } = await supabase
          .from('product_groups')
          .insert(productGroups);

        if (relationError) {
          console.error('Error creating product-group relationships:', relationError);
          result.productGroups.success = false;
        } else {
          result.productGroups.count += productGroups.length;
          console.log(`Created ${productGroups.length} product-group relationships`);
        }
      }
    } catch (error) {
      console.error(`Error processing group ${group.name}:`, error);
      result.groups.success = false;
    }
  }
  
  return result;
};
